import {css} from '@emotion/react'
import AppleIcon from '../../../images/app/AppleIcon.svg'
import {iOSAppStoreLink} from '../../../util/appDownloadLinks'
import {EVENTS, logDplWithAppParams} from '../../../util/dpl'
import {getCountry} from '../../../util/getCountry'

const translations = {
    en: {
        downloadOn: 'Download on the',
        appStore: 'App Store',
    },
    de: {
        downloadOn: 'Laden im',
        appStore: 'App Store',
    },
    nl: {
        downloadOn: 'Downloaden op de',
        appStore: 'App Store',
    },
}

const IOSButton = ({languageCode = 'en', experiment, os, browser, ctaType}) => {
    const text = translations[languageCode]
    return (
        <a
            href={iOSAppStoreLink}
            aria-label={`${text.downloadOn} ${text.appStore}`}
            css={css`
                display: inline-flex;
                padding: 12px 18px 12px 20px;
                align-items: center;
                border: 2px solid #a6a6a6;
                border-radius: 10px;
                background: black;
                color: white;
                svg {
                    transform: scale(1.73);
                }
                svg path {
                    fill: white;
                }
                p {
                    margin: 0 !important;
                }
            `}
            onClick={() => {
                logDplWithAppParams(EVENTS.StartpageAppCtaClick, {
                    os,
                    country: getCountry(),
                    type: ctaType,
                    experiment,
                })
            }}
        >
            <AppleIcon />
            <div
                className="text"
                css={css`
                    margin-left: 18px;
                    text-align: left;
                    p {
                        margin: 0;
                        line-height: 1.1;
                        color: white;
                    }
                `}
            >
                <p
                    className="download-on"
                    css={css`
                        font-size: 15px !important;
                    `}
                >
                    {text.downloadOn}
                </p>
                <p
                    className="app-store"
                    css={css`
                        font-size: 28px !important;
                        font-weight: 500;
                    `}
                >
                    {text.appStore}
                </p>
            </div>
        </a>
    )
}

export default IOSButton
